import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class DeleteFavorite extends AbstractRequestTask {

  constructor(object_id = '', live = false, version='v1') {
    super();
    this._object_id = object_id;
    this._live = live;
    this.version = version;
  }

  getHeaders() {
    return {};
  }

    getUrl() {

      const protocol = 'https';
      const server = Launcher.get("akamai_mfwk");
      const endpoint = 'services/user';
      const version = this.version;
      const apiname = 'favoritedel';
      
      return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
    }

  getParams() {
    const params = super.getParams();
    const object_id = this._object_id;
    const live = this._live;
    const device_id = Device.getDevice().getConfig().device_id;
    const object_type = 1;
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { object_id, device_id, object_type, live });
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default DeleteFavorite;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/DeleteFavoriteTask.js